import React, { FC } from 'react';
import cls from 'classnames';

import { LegalProps } from './Legal.types';
import { LegalString } from '../../../components';

const Legal: FC<LegalProps> & { String: typeof LegalString } = (props) => {
	const { hasFootnote, className, children } = props;
	return (
		<ol className={cls('layout-information-legal', { hasFootnote }, className)}>
			{children}
		</ol>
	);
};

Legal.displayName = 'Legal';
Legal.String = LegalString;

export default Legal;
